/* eslint-disable max-len */
/* eslint-disable arrow-body-style */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-bitwise */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import {
  useState, useEffect, useRef, useCallback, useContext,
} from 'react';
import { useHistory } from 'react-router-dom';
import AgoraRTM from 'agora-rtm-sdk';

import Swal from 'sweetalert2';
import {
  Avatar,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import NumberFormatter from '@shared/utils/NumberFormatter';
import LiveStatsFormatter from 'shared/utils/LiveStatsFormatter';
import NumberWithCommas from '@shared/utils/NumberWithCommas';
import LoadingIndicator from '@shared/components/LoadingIndicator/LoadingIndicator';
import LoginModalComponent from '@features/Authentication';

import sendPlane from '@assets/images/livestream/Path4302.png';
import coin from '@assets/images/coin-logo.png';
import defaultImage from '@assets/images/livestream/default_avatar.png';
import diamond from '@assets/images/livestream/diamond.png';
import view from '@assets/images/livestream/view.png';
import openSlot from '@assets/images/livestream/audio/Co-Hosting-open.png';
import lockSlot from '@assets/images/livestream/audio/Co-Hosting-lock.png';

// ban and lock
import LockUser from '@features/UserAccountLock';
import { getFilteredWords, getUser } from '@shared/services/userApi';
import BanUser from '@features/UserAccountBan/components/UserAccountBan';

import './ChatStream.css';
import giftImage from '@assets/images/gift-icon.png';
import { UserContext } from '@context/UserContext';

function ChatStream({
  channelId,
  rtmId,
  rtmToken,
  userLoggedIn,
  videoSlots,
  campaignId = null,
  hideStreamDiamond = null,
  video,
  ...props
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const swalWithButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn-okay',
    },
    buttonsStyling: false,
  });
  const { loggedIn } = useContext(UserContext); // profile data - store
  const [isLoadingRtm, setIsLoadingRtm] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const getLoggedInAction = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, []);

  const modalActions = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, []);

  const [liveStats, setLiveStats] = useState({
    viewCount: 0,
    diamondCount: 0,
    redDiamondCount: 0,
    likeCount: 0,
  });

  const history = useHistory();

  const [textArea, setTextArea] = useState(''); // Chat input

  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState([]);
  const [previousMessage, setPreviousMessage] = useState('');

  // ban and lock feat
  const [userBanDetails, setUserBanDetails] = useState([]);
  const [updatedLoggedIn, setUpdatedLoggedIn] = useState([]);
  const [banModalStatus, setBanModalStatus] = useState(false);

  // Agora set up
  const appId = process.env.REACT_APP_AGORA_APP_ID;
  const rtmClient = AgoraRTM.createInstance(appId, { logFilter: AgoraRTM.LOG_FILTER_OFF });
  const channel = useRef(rtmClient.createChannel(channelId)).current;
  const [userCoin, setUserCoin] = useState(loggedIn.coin);

  useEffect(
    () => function NavigatePath() {
      channel.leave();
      rtmClient.logout();
    },
    [],
  );

  const initRtm = () => {
    // rtm login
    rtmClient.login({
      uid: rtmId,
      token: rtmToken,
    }).then(() => {
      // rtm join channel
      channel.join();
      setIsLoadingRtm(false);
    });
  };

  useEffect(() => {
    setIsLoadingRtm(true);
    initRtm();
  }, []);

  const audioSlotsUpdate = (body) => {
    let perSlot = 0; // slot class
    let perGrid = 0; // grid class

    for (let index = 1; index < body.slots.length + 1; index++) {
      if (index === 1 || index === 4 || index === 7 || index === 10) {
        perGrid++;
      }
      if (index % 3 === 1) {
        perSlot = 0;
      } else {
        perSlot++;
      }

      const userUsername = document.getElementsByClassName(`username-${perGrid - 1}-${perSlot}`)[0];
      const userDiamond = document.getElementsByClassName(`diamond-${perGrid - 1}-${perSlot}`)[0];
      const audioIconMute = document.getElementsByClassName(`audio-muted-${perGrid - 1}-${perSlot}`)[0];
      const audioIcon = document.getElementsByClassName(`audio-${perGrid - 1}-${perSlot}`)[0];

      if (body.slots[index - 1].hasOwnProperty('user')) {
        const textDiamond = document.createTextNode(
          NumberFormatter(body.slots[index - 1].user.diamond, 1),
        );

        const imageElement = document.createElement('img');
        imageElement.src = diamond;
        imageElement.setAttribute('alt', 'diamond');
        imageElement.setAttribute('width', '12');
        imageElement.setAttribute('height', '8');
        imageElement.style.marginRight = '3px';

        userDiamond.innerHTML = '';
        userDiamond.appendChild(imageElement);
        userDiamond.appendChild(textDiamond);
      } else {
        userUsername.innerHTML = '';
        userDiamond.innerHTML = '';
        audioIcon.style.display = 'none';
        audioIconMute.style.display = 'none';

        const slot = document.getElementsByClassName(`slotImage-${perGrid - 1}-${perSlot}`)[0];
        if (body.slots[index - 1].locked === 1) {
          slot.src = lockSlot;
        } else {
          slot.src = openSlot;
        }
      }
    } // end for
  };

  const handleMessageReceived = (arr) => {
    const { body } = arr;
    // 300 Simple Chats,
    // 600 Gifts,
    // 1001 User joined,
    // 1004 is now Following,
    // 303 Share,
    // 304 record a Klip,
    // 3400 VIP Entered the Stream!
    if (arr.op === 300
      || arr.op === 600
      || arr.op === 1001
      || arr.op === 1004
      || arr.op === 303
      || arr.op === 304
      || arr.op === 3400) {
      setCurrentMessage(arr);
    } else if (arr.op === 701) {
      setLiveStats({
        viewCount: body.audience_count,
        diamondCount: body.diamonds,
        redDiamondCount: body.red_diamond,
        likeCount: body.like_num,
      });
    } else if (arr.op === 3600) {
      if (body.user_guid === loggedIn.guid) {
        props.blockUser();
      }
    }
    if (video === '3') {
      if (arr.op === 800) {
        if (body.slots.length > 0) {
          audioSlotsUpdate(body);
        } // end if
      }
    }
  };

  useEffect(() => {
    channel.on('ChannelMessage', ({ text }) => {
      const arr = JSON.parse(text);
      handleMessageReceived(arr);
    });
  }, []);

  const coinsLink = process.env.REACT_APP_COINS_BASE_URL;
  const redirectToBuyCoins = () => {
    if (process.env.REACT_APP_COINS_REFACTOR === 'true') {
      history.push('/coins', { pathName: window.location.pathname });
    } else {
      window.open(coinsLink, '_blank');
    }
  };

  useEffect(() => {
    if (messages.length >= 100) {
      messages.splice(0, 51);
    }
    if (currentMessage) setMessages([...messages, currentMessage]);
  }, [currentMessage]);

  function replaceWithAsterisk(string, search, replace) {
    return string.split(search).join(replace);
  }
  const generateRandomValue = () => {
    // secure number generator (custom math.random)
    const integerGenerator = new Uint32Array(2);
    const mantissa = (crypto.getRandomValues(integerGenerator)[0] * 2 ** 20)
    + (crypto.getRandomValues(integerGenerator)[1] >>> 12);
    // get the floating result
    return mantissa * 2 ** -52;
  };
  function declareChat(userInput, userAttr) {
    // declare params
    const contentColor = '#FFFFFF';
    const contentProductName = 'Default';
    const color = Math.floor((generateRandomValue() * 3));
    let fontColor = '';
    if (color === 0) {
      fontColor = '#4EE1CA';
    } else if (color === 1) {
      fontColor = '#00C7FF';
    } else if (color === 2) {
      fontColor = '#FF4467';
    } else if (color === 3) {
      fontColor = '#FE9A8B';
    }

    const messageParams = {
      nickname: userAttr.nickname,
      username: userAttr.username,
      avatar: userAttr.avatar,
      content: userInput,
      font_color: fontColor,
      rgb: contentColor,
      product_name: contentProductName,
      guid: userAttr.guid,
      level: userAttr.level,
      create_time: userAttr.create_time,
      type: 300,
      level_img: userAttr.level_img,
    };

    const msgId = Math.floor((generateRandomValue() * 9999999999) + 1);
    const messageCode = 300;

    const sendData = {
      client_message_id: msgId,
      op: messageCode,
      body: messageParams,
    };

    const text = JSON.stringify(sendData);

    channel
      .sendMessage({ text })
      .then(() => {
        const arr = JSON.parse(text);
        setCurrentMessage(arr);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function filterChat(userChat, user) {
    getFilteredWords()
      .then((banWords) => {
        if (banWords.data.code === '200') {
          const blockWords = banWords.data.data.block_word;
          const whitelisted = banWords.data.data.whitelisted_word_list;

          const chatToLowercase = userChat.toLowerCase();
          for (const i in blockWords) {
            if (chatToLowercase.includes(blockWords[i].toLowerCase())) {
              if (!whitelisted.includes(userChat)) {
                let asterisk = '*';
                asterisk = asterisk.repeat(blockWords[i].length);
                userChat = replaceWithAsterisk(userChat, blockWords[i], asterisk);
              }
            }
          }
          declareChat(userChat, user);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const sendChannelMessage = (inputText, user) => {
    filterChat(inputText, user);
  };

  // submit message onEnter
  const submitMessage = (e) => {
    const chatMsg = e.target.value;
    if (e.charCode === 13) {
      if (userLoggedIn.length !== 0) { // Check logged In
        if (textArea.trim().length === 0) {
          return (
            swalWithButtons.fire({
              text: 'Chat or ask a question...',
              confirmButtonText: 'Okay',
            })
          );
        }
        if (chatMsg.trim() === previousMessage) {
          return (
            swalWithButtons.fire({
              text: 'Please don\'t copy+paste comments',
              confirmButtonText: 'Okay',
            }),
            setTextArea('')
          );
        }
        if (textArea.length >= 100) {
          return (
            swalWithButtons.fire({
              text: 'Max of 100 characters',
              confirmButtonText: 'Okay',
            })
          );
        }
        setPreviousMessage(chatMsg.trim());
        sendChannelMessage(chatMsg, userLoggedIn);
        setTextArea('');
      } else {
        return (setOpenModal(true));
      }
    }
  };

  // submit message onClick
  const onClickSubmitMessage = () => {
    if (userLoggedIn.length !== 0) { // Check logged In
      if (textArea.trim().length === 0) {
        return (
          swalWithButtons.fire({
            text: 'Chat or ask a question...',
            confirmButtonText: 'Okay',
          })
        );
      }
      if (textArea.trim() === previousMessage) {
        return (
          swalWithButtons.fire({
            text: 'Please don\'t copy+paste comments',
            confirmButtonText: 'Okay',
          }),
          setTextArea('')
        );
      }
      if (textArea.length >= 100) {
        return (
          swalWithButtons.fire({
            text: 'Max of 100 characters',
            confirmButtonText: 'Okay',
          })
        );
      }
      setPreviousMessage(textArea.trim());
      sendChannelMessage(textArea, userLoggedIn);
      setTextArea('');
    } else {
      return (setOpenModal(true));
    }
  };

  // check banned accounts commenting
  const checkBanStatus = async (userData, userEvent) => {
    if (userData.user_status === 'ban' || userData.user_status === 'lock') {
      setBanModalStatus(true);
    } else if (userData.user_status === 'normal') {
      if (userEvent.type === 'keypress' && userEvent.type !== 'click') {
        submitMessage(userEvent);
      } else if (userEvent.type === 'click' && userEvent.target.className !== 'input-text-box') {
        onClickSubmitMessage();
      }
    }
  };

  // manage banned accounts
  const sendChat = async (evnt) => {
    if (userLoggedIn.length === 0) {
      setOpenModal(true);
    } else if (evnt.key === 'Enter') {
      await getUser(userLoggedIn.username)
        .then(async (userRes) => {
          if (userRes.data.code === '200') {
            setUpdatedLoggedIn(userRes.data.data);
            setUserBanDetails(userRes.data.data.banDetails);
            await checkBanStatus(userRes.data.data, evnt);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const sendChatClick = async (e) => {
    if (userLoggedIn.length === 0) {
      setOpenModal(true);
    } else {
      await getUser(userLoggedIn.username)
        .then(async (userRes) => {
          if (userRes.data.code === '200') {
            setUpdatedLoggedIn(userRes.data.data);
            setUserBanDetails(userRes.data.data.banDetails);
            await checkBanStatus(userRes.data.data, e);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const renderBanOrLockModal = () => {
    if (updatedLoggedIn.user_status === 'ban') {
      return (<BanUser banModalStatus={banModalStatus} userBanDetails={userBanDetails} />);
    } else if (updatedLoggedIn.user_status === 'lock') {
      return (<LockUser banModalStatus={banModalStatus} />);
    }
  };

  // Scroll functions
  const chatScroll = document.getElementById('chat-messages-inner');
  const listInnerRef = useRef();
  const [seeLatestComment, setSeeLatestComment] = useState(false);
  const [autoScroll, setAutoScroll] = useState(false);
  const scrollRef = listInnerRef;

  const onScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const scrollPosition = scrollTop + clientHeight;
      if (scrollPosition < scrollHeight) {
        setSeeLatestComment(true);
      } else {
        setSeeLatestComment(false);
        setAutoScroll(false);
      }
    }
  };
  useEffect(() => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const scrollPosition = scrollTop + clientHeight;
      const checkAutoScroll = scrollPosition < scrollHeight;

      if (!checkAutoScroll) return setAutoScroll(true);
    }
  }, [currentMessage]);

  useEffect(() => {
    if (scrollRef.current) {
      const { scrollHeight } = scrollRef.current;
      if (autoScroll) return (chatScroll?.scrollTo({ top: scrollHeight, behavior: 'smooth' }));
    }
  }, [messages]);

  const scrollDownButton = () => {
    if (scrollRef.current) {
      const { scrollHeight } = scrollRef.current;
      return (chatScroll?.scrollTo({ top: scrollHeight, behavior: 'smooth' }));
    }
  };

  // Messages
  const simpleMessage = (chat, index) => (
    <Grid container key={index} className='chat-message' alignItems='center' justifyContent='flex-start'>
      <Avatar className='chat-avatar' src={chat.body.avatar} />
      {isMobile
        ? (
          <div className='simple-message'>
            <Typography className='message-text'>
              <font className='username-text'>{chat.body.username && `${chat.body.username} `}</font>
              {chat.body.content}
            </Typography>
          </div>
        )
        : (
          <div className='simple-message'>
            <Typography className='message-text username-text'>{chat.body.username}</Typography>
            <Typography className='message-text'>{chat.body.content}</Typography>
          </div>
        )}
    </Grid>
  );

  const shareMessage = (chat, index) => (
    <Grid container key={index} className='chat-message' alignItems='center' justifyContent='flex-start'>
      <Avatar className='chat-avatar' src={chat.body.avatar} />
      <div className='share-message'>
        <Typography className='message-text'>
          <font className='username-text'>{chat.body.username && `${chat.body.username} `}</font>
          {chat.body.content}
        </Typography>
      </div>
    </Grid>
  );

  const giftMessage = (chat, index) => (
    <Grid container key={index} className='chat-message' alignItems='center' justifyContent='flex-start'>
      <Avatar className='chat-avatar' src={chat.body.avatar} />
      <div className='gift-message'>
        <Typography className='message-text'>
          <font className='username-text'>{chat.body.username}</font>
          {' '}
          sent a
          {' '}
          {chat.body.name}
          {' '}
          <img src={chat.body.image} alt='gift icon' />
          {' '}
          x
          {chat.body.repeat}
        </Typography>
      </div>
    </Grid>
  );

  const joinedMessage = (chat, index) => {
    if (chat.body.username) {
      return (
        <Grid container key={index} className='chat-message' alignItems='center' justifyContent='flex-start'>
          <Avatar className='chat-avatar' src={chat.body.avatar ? chat.body.avatar : defaultImage} />
          <div className='joined-message'>
            <Typography className='message-text'>
              <font className='username-text'>{chat.body.username}</font>
              {' '}
              joined
            </Typography>
          </div>
        </Grid>
      );
    }

    const { content } = chat.body;
    const username = content.substr(0, content.indexOf('joined'));
    return (
      <Grid container key={index} className='chat-message' alignItems='center' justifyContent='flex-start'>
        <Avatar className='chat-avatar' src={chat.body.avatar ? chat.body.avatar : defaultImage} />
        <div className='joined-message'>
          <Typography className='message-text'>
            <font className='username-text'>{username}</font>
            {' '}
            joined
          </Typography>
        </div>
      </Grid>
    );
  };

  const renderMessages = () => {
    const keys = Object.keys(messages);

    const streamChat = (chat, index) => {
      if (chat.body) {
        if (chat.op === 300) {
          if (chat.op === 300 && chat.body.type === 303) {
            return (
              shareMessage(chat, index)
            );
          }
          return (
            simpleMessage(chat, index)
          );
        } else if (chat.op === 303) {
          return (
            shareMessage(chat, index)
          );
        } else if (chat.op === 600) {
          return (
            giftMessage(chat, index)
          );
        } else if (chat.op === 1001 && chat.body.type === 1001) {
          return (
            joinedMessage(chat, index)
          );
        } else {
          return (
            simpleMessage(chat, index)
          );
        }
      }
      return null;
    };

    return (
      <>
        {keys.map((data, index) => {
          return (
            streamChat(messages[data], index)
          );
        })}
      </>
    );
  };

  function SeeLatestCommentButton() {
    if (seeLatestComment) {
      if (autoScroll === false) {
        return (
          <Grid container className='see-latest-comment' alignItems='center' justifyContent='center'>
            <button className='see-latest-button' onClick={scrollDownButton}>See latest comments</button>
          </Grid>
        );
      }
    }
    return null;
  }

  const renderCoinsCount = () => {
    if (userLoggedIn.length !== 0) {
      return (
        <Grid container className='chat-user-coin MuiTabs-flexContainer' style={{ flexDirection: 'row', display: 'flex' }} alignItems='center' justifyContent='space-between'>
          <Grid item lg={6}>
            <Grid
              className='MuiTabs-flexContainer'
              style={{
                alignItems: 'center', display: 'flex', justifyContent: 'flex-start', flexDirection: 'row',
              }}
            >
              <img src={coin} alt='coin' height='15' />
              <Typography id='coin-text' className='coin-text'>
                {NumberWithCommas(userCoin)}
              </Typography>
            </Grid>
          </Grid>
          <Grid item lg={6}>
            <div className='coinsTopUp' onClick={redirectToBuyCoins}>
              Top Up
            </div>
          </Grid>
        </Grid>
      );
    }
  };

  const renderGiftIcon = () => (
    <button
      className='sendVg'
      onClick={props.openVgSelection}
      style={{
        backgroundColor: 'transparent', border: '0', cursor: 'pointer', paddingTop: '7px',
      }}
    >
      <img src={giftImage} alt='sendVg' width='20px' />
    </button>
  );

  const renderChatBottom = () => (
    <Grid container className='chat-input' alignItems='center' justifyContent='space-between'>
      <input className='input-text-box' type='text' name='message' placeholder='Write a message...' autoComplete='off' maxLength='100' onChange={(e) => setTextArea(e.target.value)} onKeyPress={sendChat} value={textArea} onClick={sendChat} />
      <button className='input-send' onClick={sendChatClick}>
        <img src={sendPlane} alt='send' />
      </button>
      {renderGiftIcon()}
    </Grid>
  );

  const renderInputMessages = () => {
    if (isMobile) {
      return (
        <div style={{ width: '100%', paddingLeft: 10, paddingRight: 10 }}>
          <div className='chat-bottom'>
            {renderChatBottom()}
            {renderCoinsCount()}
          </div>
        </div>
      );
    }
    return null;
  };

  const mobileContainerStyle = () => {
    if (videoSlots === '1' || videoSlots === '2' || videoSlots === '3' || videoSlots === '101') {
      return 'chat-box-container-mobile-first';
    }
    return 'chat-box-container-mobile-second';
  };

  const diamondCounts = () => {
    if (campaignId !== null) {
      if (hideStreamDiamond === 1) {
        // eslint-disable-next-line no-useless-return
        return;
      } else {
        return (
          <>
            <img src={diamond} alt='red_diamond' width='20' height='16' style={{ marginRight: '5px' }} />
            <Typography className='diamonds' style={{ color: '#FFFFFF' }}>
              {LiveStatsFormatter(liveStats.redDiamondCount.toString())}
            </Typography>
          </>
        );
      }
    } else {
      return (
        <>
          <img src={diamond} alt='diamond' width='20' height='16' style={{ marginRight: '5px' }} />
          <Typography className='diamonds' style={{ color: '#FFFFFF' }}>
            {LiveStatsFormatter(liveStats.diamondCount.toString())}
          </Typography>
        </>
      );
    }
  };

  const liveStatsWidth = () => {
    if (isTablet) {
      return '62vw';
    }
    return '70vw';
  };

  const renderLiveStats = () => {
    if (isMobile) {
      return (
        <div style={{ marginLeft: 10, marginBottom: 10 }}>
          <div className='live-stats'>
            <Grid container className='live-stats-text' alignItems='center' justifyContent='flex-start'>
              <img src={view} alt='view' width='23' height='15' style={{ marginRight: '5px' }} />
              <Typography className='views'>
                {LiveStatsFormatter(liveStats.viewCount.toString())}
              </Typography>
                            &nbsp;&nbsp;
              {(diamondCounts())}
            </Grid>
          </div>
        </div>
      );
    }
    return (
      <div style={{
        position: 'absolute', top: 160, bottom: 0, right: 0, left: 35, width: liveStatsWidth(), paddingRight: 10, justifyContent: 'flex-end', display: 'flex', height: '10px',
      }}
      >
        <div className='live-stats'>
          <Grid container className='live-stats-text' alignItems='center' justifyContent='flex-start'>
            <img src={view} alt='view' width='23' height='15' style={{ marginRight: '5px' }} />
            <Typography className='views'>
              {LiveStatsFormatter(liveStats.viewCount.toString())}
            </Typography>
                        &nbsp;&nbsp;
            {(diamondCounts())}
          </Grid>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setUserCoin(props.userCoin !== '' ? props.userCoin : loggedIn.coin);
  }, [props.userCoin]);

  return (
    <>
      {isLoadingRtm
        ? <LoadingIndicator />
        : (
          <>
            {openModal && (
              <LoginModalComponent
                isOpenModal={openModal}
                modalFunc={modalActions}
                loggedInFunc={getLoggedInAction}
              />
            )}
            <Hidden mdUp>
              <div className={mobileContainerStyle()}>
                <div className='chat-box chat-box-sub-container-mobile'>
                  <div className='chat-box-body-mobile'>
                    <div className='chat-messages'>
                      <div className='chat-messages-inner' id='chat-messages-inner' onScroll={onScroll} ref={listInnerRef}>
                        {renderMessages()}
                      </div>
                    </div>
                  </div>
                </div>
                <SeeLatestCommentButton />
              </div>
            </Hidden>
            {renderLiveStats()}
            {renderInputMessages()}
            <Grid container className='livestream-container'>
              <Hidden smDown>
                <Grid item className='chat-container'>
                  <div className='chat-header'>
                    <Typography className='chat-title'>Chat</Typography>
                  </div>
                  <div className='chat-box'>
                    <div className='chat-box-body'>
                      <div className='chat-messages'>
                        <div className='chat-messages-inner' id='chat-messages-inner' onScroll={onScroll} ref={listInnerRef}>
                          {renderMessages()}
                        </div>
                        <SeeLatestCommentButton />
                      </div>
                      <div className='chat-bottom'>
                        {renderChatBottom()}
                        {renderCoinsCount()}
                      </div>

                    </div>
                  </div>
                </Grid>
              </Hidden>
            </Grid>
          </>
        )}

      { banModalStatus === false ? '' : renderBanOrLockModal() }
    </>
  );
}

export default ChatStream;
